<script>
	// Stores 
	import { alt } from '../store.js';  

	// Componentes
	import { link }		from "svelte-routing";
	import PageHeader	from './../components/PageHeader.svelte';

	// Code
	let titlePage = 'Fichas Cadastrais';    
</script>

<PageHeader title={titlePage}></PageHeader>    

<div class="container">
	<p>Para efetuar seu cadastro, preencha o formulário correspondente ao seu perfil abaixo:</p>
	<hr>
	<div class="mb-10">
		<a class="btn btn-rounded btn-primary" style="border: 2px solid #ffffff !important;" target="_blank" href="/assets/files/fichaCadastralFiador.pdf">
			<b>Ficha Cadastral - Fiador </b>
		</a>
	</div>
	<div class="mb-10">
		<a class="btn btn-rounded btn-primary" style="border: 2px solid #ffffff !important;" target="_blank" href="/assets/files/fichaCadastralInquilino.pdf">
			<b>Ficha Cadastral - Inquilino</b>
		</a>
	</div>
	<div class="mb-10">
		<a class="btn btn-rounded btn-primary" style="border: 2px solid #ffffff !important;" target="_blank" href="/assets/files/fichaCadastralPJ.pdf">
			<b>Ficha Cadastral - Pessoa Jurídica</b>
		</a>
	</div>
	<hr>
	<p>Em caso de dúvidas, entre em <a href="/contato" use:link>contato</a> conosco, nossa equipe está à disposição para auxiliar.</p>
	<div class="button text-center mt-40">
		<a href="/documentacao-necessaria" use:link replace title="Confira a documentação necessária para locação" class="btn btn-primary">Confira a Documentação para Locação <i class="far fa-arrow-right"></i></a>
	</div>
	<br />

</div>